<footer class="footer">
  <nav class="footer__nav">
    <ul>
      <li>
        <a
          href="https://www.fortasolutions.com/forta-terms-of-use/"
          target="_blank"
          class="underline"
          >{{ 'footer.termsOfUse' | translate }}</a
        >
      </li>
      <li>
        <a
          href="https://www.fortasolutions.com/forta-privacy-policy/"
          target="_blank"
          class="underline"
          >{{ 'footer.privacyPolicy' | translate }}</a
        >
      </li>
      <li>
        <a href="mailto:{{ contactUsMail }}" class="underline">{{
          'footer.contactUs' | translate
        }}</a>
      </li>
    </ul>
    <p class="footer__copyright">
      &copy; <span class="color-pink">Forta Solutions</span>, {{ currentYear }}.
      All rights reserved.
    </p>
  </nav>
</footer>
